// extracted by mini-css-extract-plugin
module.exports = {"categories__list":"LocationCategoriesList_categories__list__KhnJC"};